import { useState } from "react";

const MIN_LEVEL = 0;
const MAX_LEVEL = 100;
const PACE_SOUND = 10;
const VOLUME_DEFAULT = 50;

export const useMediaSound = () => {
  const [volume, setVolume] = useState(VOLUME_DEFAULT);

  const upSound = () => {
    if (volume + PACE_SOUND > MAX_LEVEL) {
      return;
    }
    setVolume(volume + PACE_SOUND);
  };

  const downSound = () => {
    if (volume - PACE_SOUND < MIN_LEVEL) {
      return;
    }
    setVolume(volume - PACE_SOUND);
    return volume;
  };

  return {
    volume,
    downSound,
    upSound,
  };
};
